import { render } from "./ShareBottomBar.vue?vue&type=template&id=3a3b56a4&scoped=true"
import script from "./ShareBottomBar.vue?vue&type=script&lang=js"
export * from "./ShareBottomBar.vue?vue&type=script&lang=js"

import "./ShareBottomBar.vue?vue&type=style&index=0&id=3a3b56a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3b56a4"]])

export default __exports__